const CAP51 = {
  "id": 313,
  "title": "Sidechains de Bitcoin",
  "slug": "sidechains-de-bitcoin",
  "type": "lesson",
  "category": "bitcoin-avanzado",
  "level": "advanced",
  "preview": "Qué son las sidechains, cómo funcionan, para qué sirven y cuáles son las principales sidechains del ecosistema Bitcoin como RSK y Liquid.",
  "sections": [
    {
      "heading": "¿Qué son las Sidechains?",
      "text": [
        "Las cadenas laterales o *sidechains* cumplen un papel fundamental en la evolución del ecosistema Bitcoin. Estas permiten ampliar las capacidades de la blockchain principal sin modificar su protocolo base.",
        "Una sidechain es básicamente una blockchain independiente que se ejecuta en paralelo a Bitcoin y que mantiene una relación con esta mediante un mecanismo de comunicación bidireccional. Gracias a este vínculo, es posible mover BTC hacia la sidechain, utilizarlos allí bajo otras reglas y luego retornar nuevamente a la cadena principal.",
        "Esto permite habilitar nuevas funciones, como contratos inteligentes, mayor velocidad de transacciones, privacidad adicional o la interoperabilidad con otras redes, sin poner en riesgo la seguridad del protocolo original.",
        "Un ejemplo común es enviar BTC a una sidechain, donde se transforman en un token equivalente, que luego puede utilizarse en otros entornos e incluso interoperar con blockchains como Ethereum."
      ]
    },
    {
      "heading": "¿Para qué sirven las Sidechains?",
      "text": [
        "El propósito principal de las sidechains es expandir las funcionalidades disponibles sobre Bitcoin sin alterar la capa base.",
        "Entre sus usos más relevantes destacan:",
        "- Permitir contratos inteligentes complejos sin cambiar Bitcoin.",
        "- Facilitar interoperabilidad entre blockchains.",
        "- Aumentar la privacidad y velocidad en ciertas operaciones.",
        "- Crear redes especializadas para activos financieros.",
        "- Implementar mejoras experimentales sin afectar la red principal.",
        "En esencia, permiten innovar sin comprometer la seguridad de Bitcoin."
      ]
    },
    {
      "heading": "RSK (RootStock)",
      "text": [
        "RootStock, mejor conocida como **RSK**, es una sidechain diseñada específicamente para llevar **contratos inteligentes** a la red Bitcoin sin modificar su protocolo.",
        "RSK utiliza el mecanismo de **merged mining**, lo que le permite aprovechar directamente el poder de hash de Bitcoin. Así obtiene seguridad de nivel Bitcoin, mientras ofrece un entorno programable similar al de Ethereum.",
        "La red funciona mediante un puente bidireccional que conecta ambas blockchains. Gracias a este puente, BTC puede trasladarse y convertirse en **RBTC**, un token 1:1 equivalente al bitcoin original, utilizado dentro de RSK.",
        "RSK está basada en el lenguaje Solidity y permite crear aplicaciones descentralizadas (dApps) y contratos inteligentes complejos sobre Bitcoin, replicando funcionalidades típicas de Ethereum pero con la robustez del ecosistema Bitcoin."
      ]
    },
    {
      "heading": "Liquid Network",
      "text": [
        "Liquid Network es una sidechain creada por la empresa Blockstream, enfocada en transacciones más rápidas, confidenciales y orientadas a mercados financieros.",
        "Liquid permite la emisión y liquidación eficiente de activos digitales como:",
        "- Stablecoins",
        "- Security tokens",
        "- Activos empresariales",
        "- Instrumentos financieros tokenizados",
        "Liquid utiliza un token nativo llamado **L-BTC**, que también mantiene una relación de 1:1 con BTC. Cuando un usuario mueve bitcoins hacia Liquid, recibe L-BTC para operar dentro de la sidechain, disfrutando de mayor privacidad y velocidad.",
        "Su diseño está pensado para intercambios entre empresas, brokers, instituciones y usuarios que requieren transacciones más rápidas sin sacrificar la conexión directa con Bitcoin."
      ]
    }
  ]
}


export default CAP51;
